export default __webpack_public_path__ + "static/media/slideshare.5b30735a.svg";